import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

let PatrickLogo = props => {
  props = Object.assign(
    { viewBox: '0 0 648.2 521', color: 'rgba(255, 255, 255, 0.15)' },
    props
  );

  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M628.5,501.8c-4.9-0.9-10.4-1.9-16.7-2.8c-3.2-0.5-6.5-0.9-10-1.4c-1.8-0.2-3.6-0.5-5.4-0.7c-1.9-0.2-3.7-0.5-5.7-0.7
		c-7.8-0.9-16.3-1.7-25.4-2.4c-2.3-0.2-4.6-0.4-6.9-0.5c-2.3-0.2-4.7-0.3-7.2-0.5c-2.4-0.2-4.9-0.3-7.3-0.5c-2.5-0.1-5-0.3-7.5-0.4
		c-2.6-0.1-5.1-0.3-7.7-0.4c-2.6-0.1-5.2-0.2-7.9-0.3c-1.3-0.1-2.7-0.1-4-0.2c-1.3,0-2.7-0.1-4-0.1c-2.7-0.1-5.4-0.2-8.1-0.3
		c-10.9-0.3-22.1-0.5-33.5-0.5h-2.1h-2.2c-1.5,0-2.9,0-4.4,0s-3,0-4.5,0h-2.2h-2c-2.6,0-5.3,0.1-7.9,0.1h-2h-0.5h-0.7h-0.3h-1.1
		c-1.4,0-2.9,0.1-4.3,0.1c-2.9,0.1-5.7,0.1-8.6,0.2c-1.4,0-2.9,0.1-4.3,0.1c-1.4,0.1-2.8,0.1-4.3,0.2c-2.8,0.1-5.7,0.2-8.6,0.3
		c-1.4,0.1-2.9,0.1-4.3,0.2l-4.2,0.2c-5.6,0.3-11.3,0.5-16.8,0.9c-5.5,0.3-11.1,0.6-16.5,1s-10.9,0.7-16.3,1.1
		c-5.4,0.4-10.8,0.8-16,1.2c-5.3,0.4-10.6,0.8-15.8,1.2l-7.9,0.6l-7.8,0.6c-20.8,1.6-41.2,3.3-61.3,4.8c-10,0.8-20.1,1.5-29.8,2.2
		c-4.7,0.3-10.1,0.7-15.1,1c-1.3,0.1-2.5,0.2-3.8,0.2c-1.2,0.1-2.4,0.1-3.7,0.2c-2.4,0.1-4.9,0.3-7.3,0.4c-19.4,1.2-38.8,2-57.5,2.5
		c-2.3,0.1-4.7,0.1-7,0.2c-2.3,0.1-4.6,0.1-6.9,0.2c-4.6,0.1-9.1,0.2-13.6,0.2c-8.9,0.1-17.6,0.1-26,0.1c-2.1,0-4.2,0-6.2-0.1
		c-2,0-4.1-0.1-6.1-0.1s-4-0.1-5.9-0.1s-3.9-0.1-5.8-0.1c-7.6-0.2-14.8-0.5-21.5-0.8c-10.6-0.5-20-1.1-27.8-1.8v2.2
		c1.7,0.2,3.5,0.4,5.3,0.5c5.9,0.6,12.3,1.1,19.4,1.6c14.1,1,30.5,1.8,48.6,2.3c9,0.2,18.4,0.4,28.2,0.5c4.9,0.1,9.8,0.1,14.8,0.1
		c2.5,0,5,0,7.5,0s5.1,0,7.6,0c2.6,0,5.1,0,7.7-0.1c2.6,0,5.2-0.1,7.8-0.1c5.2-0.1,10.5-0.2,15.8-0.3c2.7-0.1,5.3-0.1,7.9-0.2
		c2.7-0.1,5.3-0.2,8-0.2c5.3-0.2,10.7-0.4,16.1-0.6c2.7-0.1,5.4-0.2,8.1-0.3c1.3-0.1,2.7-0.1,4.1-0.2c1.3-0.1,2.6-0.1,3.9-0.2
		c5.3-0.2,10.4-0.4,16-0.7c5.5-0.3,11.1-0.5,16.4-0.8c5.4-0.3,10.8-0.6,16.2-0.9c21.5-1.2,42.8-2.6,64-3.9
		c21.1-1.3,42.4-2.4,63.3-3.2c10.4-0.4,20.8-0.7,31-1l3.8-0.1c1.3,0,2.5-0.1,3.8-0.1c2.5-0.1,5-0.1,7.5-0.2c5-0.1,9.9-0.2,14.8-0.3
		c1.2,0,2.4-0.1,3.7-0.1h0.9h0.1h0.3h2c2.7,0,5.3-0.1,7.9-0.1c0.6,0,1.3,0,1.9,0h1.7c1.1,0,2.3,0,3.4,0c1.1,0,2.3,0,3.4,0h1.7h1.8
		c2.4,0,4.7,0,7.1-0.1c2.3,0,4.7,0,7,0c4.6,0,9.2,0,13.7,0c18,0.1,35,0.5,50.6,1.1c2,0.1,3.9,0.2,5.8,0.3c1,0,1.9,0.1,2.8,0.1
		s1.9,0.1,2.8,0.1c1.8,0.1,3.7,0.2,5.5,0.3c1.8,0.1,3.6,0.2,5.3,0.3c3.5,0.2,7,0.4,10.2,0.7c1.6,0.1,3.3,0.2,4.9,0.4
		c1.6,0.1,3.2,0.2,4.7,0.4c12.3,1,22.8,2.1,31.2,3.1s14.7,2,18.8,2.6c0.4,0.1,0.7,0.1,1.1,0.2l0.1-3.4c-2-0.6-4.4-1.3-7.2-1.9
		C637.4,503.7,633.3,502.7,628.5,501.8z"
        />
        <path d="M0.3,264.5v178.7h94.2V277C63,276.8,31.6,273.1,0.3,264.5z" />
        <path
          d="M312.6,241.5c-25.3,6.2-50.6,12.5-75.9,18v27.3h-31.2v-21c-26.6,4.9-53.1,8.7-79.7,10.3v151.4h51.7v15.8h28V307.8h31.4
		v135.4h57.7l-28.9-187.1h31.7l24,163.1l24-163.1h28.8l-28.9,187.1h57.8V256.1h85.7v28.6h-54.3v55.7h43.1V369h-43.1v58.5h54.3v15.8
		h34.3v-17.5h30.3v17.5h94.7V226c-40-14.3-80.2-19.9-120.4-19.9C456.1,206.1,384.4,223.8,312.6,241.5z M553.9,339.5l-4,72.2h-23.4
		l-4-72.2v-83.4h31.4V339.5z"
        />
        <path
          d="M640.9,191.3c-3.5-2.6-7.6-5.4-12.5-8.3c-4.9-2.8-10.4-5.7-16.8-8.5c-3.2-1.4-6.5-2.8-10.1-4.1c-1.8-0.7-3.6-1.3-5.4-2
		c-1.9-0.6-3.7-1.3-5.7-1.9c-7.8-2.4-16.3-4.7-25.4-6.6c-2.3-0.5-4.6-0.9-6.9-1.4c-2.3-0.4-4.7-0.8-7.2-1.2
		c-2.4-0.4-4.9-0.8-7.4-1.1c-2.5-0.3-5-0.7-7.5-1c-2.6-0.3-5.1-0.5-7.7-0.8c-2.6-0.3-5.2-0.4-7.9-0.7c-1.3-0.1-2.7-0.2-4-0.3
		c-1.3-0.1-2.7-0.1-4-0.2c-2.7-0.1-5.4-0.3-8.1-0.4c-4.6-0.1-9.3-0.2-14.1-0.2c-6.4,0-12.9,0.1-19.4,0.4l-2.1,0.1l-2.2,0.1
		c-1.5,0.1-2.9,0.2-4.4,0.3c-1.5,0.1-3,0.2-4.5,0.3l-2.2,0.2l-2,0.2c-2.6,0.3-5.3,0.5-7.9,0.8l-2,0.2l-0.5,0.1l-0.7,0.1H442
		l-1.1,0.1c-1.4,0.2-2.9,0.4-4.3,0.6c-2.9,0.4-5.7,0.8-8.6,1.2c-1.4,0.2-2.9,0.4-4.3,0.6c-1.4,0.3-2.8,0.5-4.3,0.8
		c-2.8,0.5-5.7,1-8.6,1.5c-1.4,0.3-2.9,0.5-4.3,0.8l-4.2,0.9c-5.6,1.3-11.3,2.4-16.8,3.9c-5.5,1.4-11.1,2.8-16.5,4.3
		s-10.9,3-16.2,4.7c-5.4,1.6-10.8,3.2-16,4.9c-5.3,1.7-10.6,3.3-15.8,5l-7.9,2.5l-7.8,2.5c-20.8,6.7-41.2,13.4-61.2,19.7
		c-10,3.2-20.1,6.2-29.7,8.9c-4.7,1.4-10,2.8-15.1,4.2c-1.3,0.3-2.5,0.7-3.8,1c-1.2,0.3-2.4,0.6-3.7,1c-2.4,0.6-4.9,1.3-7.3,1.9
		c-19.4,5-38.8,8.9-57.4,11.8c-2.3,0.4-4.7,0.7-7,1s-4.6,0.7-6.9,0.9c-4.6,0.5-9.1,1.1-13.6,1.5c-8.9,0.9-17.6,1.4-26,1.7
		c-2.1,0.1-4.2,0.1-6.2,0.2c-2,0-4.1,0-6.1,0.1c-2,0-4,0-5.9,0c-2,0-3.9,0-5.8-0.1c-7.6-0.2-14.8-0.7-21.5-1.4
		c-7.1-0.7-13.7-1.7-19.6-2.8c0.6,0.2,1.4,0.4,2.3,0.5c0,0-10.4,2.4-10.6,2.6v2.4c1.7,0.5,3.5,1,5.4,1.5c5.9,1.5,12.3,3,19.4,4.2
		c14.1,2.5,30.6,4.3,48.6,4.8c9,0.3,18.5,0.3,28.2,0c4.9-0.1,9.8-0.4,14.8-0.6c2.5-0.1,5-0.3,7.5-0.5s5.1-0.3,7.6-0.6
		c2.6-0.2,5.1-0.5,7.7-0.7s5.2-0.6,7.8-0.8c5.2-0.6,10.5-1.3,15.8-2c2.7-0.3,5.3-0.8,7.9-1.2c2.7-0.4,5.3-0.8,8-1.2
		c5.3-0.9,10.7-1.8,16.1-2.8c2.7-0.5,5.4-1,8.1-1.6c1.3-0.3,2.7-0.5,4.1-0.8c1.3-0.3,2.6-0.5,3.9-0.8c5.3-1.1,10.4-2.1,16-3.4
		c5.4-1.2,11.1-2.4,16.4-3.8c5.4-1.3,10.8-2.6,16.1-4c21.5-5.4,42.8-11.3,63.9-16.8c21.1-5.6,42.3-10.5,63.2-14.4
		c10.4-2,20.8-3.7,30.9-5.2l3.8-0.6c1.3-0.2,2.5-0.3,3.8-0.5c2.5-0.3,5-0.7,7.5-1.1c5-0.8,9.9-1.3,14.8-1.9c1.2-0.2,2.4-0.3,3.7-0.5
		l0.9-0.1h0.1h0.3l2-0.2c2.7-0.3,5.3-0.6,7.9-0.9c0.6-0.1,1.3-0.2,1.9-0.2l1.7-0.2c1.1-0.1,2.3-0.2,3.4-0.3c1.1-0.1,2.3-0.2,3.4-0.3
		l1.7-0.2l1.8-0.1c2.4-0.2,4.7-0.4,7-0.6s4.7-0.3,7-0.5c4.6-0.4,9.2-0.5,13.7-0.8c18-0.7,35-0.5,50.6,0.7c2,0.1,3.9,0.3,5.8,0.5
		c1,0.1,1.9,0.2,2.8,0.3c0.9,0.1,1.9,0.2,2.8,0.3c1.8,0.2,3.7,0.4,5.5,0.6c1.8,0.2,3.6,0.5,5.3,0.7c3.5,0.5,7,1,10.2,1.6
		c1.6,0.3,3.3,0.6,4.9,0.9s3.2,0.6,4.7,0.9c12.3,2.6,22.9,5.6,31.3,8.5c8.4,2.9,14.7,5.7,18.8,7.7c0.4,0.2,0.7,0.4,1.1,0.6v-11.3
		C646.1,195.4,643.7,193.4,640.9,191.3z"
        />
        <path
          d="M11.9,230.2c4.7-3.4,9.4-7.4,15.8-11.2c0.8-0.5,1.6-0.9,2.5-1.4c0.8-0.5,1.7-0.9,2.5-1.4c1.7-0.9,3.6-1.8,5.4-2.7
		c0.9-0.4,1.9-0.8,2.8-1.3c1-0.4,2-0.8,2.9-1.2c0.5-0.2,1-0.4,1.5-0.6s1-0.4,1.5-0.6c1-0.4,2-0.8,3.1-1.1c8.5-2.9,17.9-5.3,28-6.9
		c2.6-0.3,5.1-0.8,7.8-1c1.3-0.1,2.6-0.4,4-0.4c1.3-0.1,2.7-0.2,4-0.4l1-0.1l1-0.1c0.7,0,1.3-0.1,2-0.1s1.3-0.1,2-0.2l1-0.1
		c0.3,0,0.7,0,1.1-0.1c1.5-0.1,3-0.1,4.6-0.2l1.1-0.1h0.2h0.1h0.5c0.7,0,1.4,0,2.1,0c2.8-0.1,5.7-0.3,8.6-0.2c1.5,0,2.9,0,4.4,0
		c0.7,0,1.5,0,2.2,0l2.2,0.1c5.9,0.1,12,0.2,18.2,0.7c12.4,0.8,25.1,2.4,37.9,4.5s25.8,4.6,38.8,6.6c4.9-0.9,42.4-12.8,42.4-12.8
		l-8-1.3c-0.8-0.1-1.5-0.3-2.3-0.4c-3-0.6-6.3-1.1-9.2-1.7c-5.9-1.2-12.1-2.5-18.2-4c-12.3-2.9-25-6.2-37.8-9.3l-4.8-1.2l-4.9-1.2
		c-3.2-0.8-6.5-1.6-9.8-2.3c-3.2-0.8-6.5-1.5-9.8-2.2c-3.3-0.8-6.6-1.4-9.9-2c-3.3-0.7-6.7-1.1-10-1.7s-6.7-0.9-10.1-1.3l-2.5-0.3
		c-0.8-0.1-1.7-0.1-2.5-0.2c-1.7-0.1-3.4-0.2-5.1-0.3c-0.8,0-1.7-0.1-2.5-0.1c-0.3,0-0.6,0-0.9,0c-0.2,0-0.5,0-0.7,0
		c-0.3,0-0.6,0-0.9,0c-1.7,0-3.4,0-5,0c-0.8,0-1.7,0-2.5,0h-0.6h-0.2h-0.4h-0.3l-1.1,0.1c-1.5,0.1-3.1,0.2-4.6,0.3l-1.2,0.1L98,169
		c-0.9,0.1-1.7,0.2-2.5,0.3c-0.8,0.1-1.7,0.2-2.5,0.3l-1.3,0.2l-1.2,0.2c-6.4,0.9-12.7,2.3-18.7,3.9c-1.5,0.4-3,0.9-4.5,1.3
		c-0.7,0.2-1.5,0.5-2.2,0.7c-0.7,0.3-1.4,0.5-2.2,0.8c-1.4,0.5-2.9,1-4.3,1.5c-1.4,0.6-2.8,1.1-4.1,1.7c-1.4,0.5-2.7,1.2-4,1.8
		c-1.3,0.6-2.6,1.2-3.9,1.9c-1.3,0.6-2.5,1.3-3.8,1.9c-1.2,0.7-2.4,1.4-3.6,2.1c-4.7,2.8-9,5.8-12.9,8.8c-1,0.8-1.9,1.6-2.8,2.3
		c-0.9,0.8-1.8,1.6-2.7,2.4c-1.7,1.5-3.3,3.2-4.8,4.7c-3,3.2-5.5,6.3-7.7,9.3s-3.9,5.9-5.4,8.6c-1.2,2.2-2.1,4.2-2.9,6.1v7.6
		c2.6,0.6,5.4,1.2,8.3,1.7C3.9,237.8,7.8,233.2,11.9,230.2z"
        />
        <path d="M8.5,239.4c-2.9-0.5-5.7-1.1-8.3-1.7v4.8c0.2-0.2,10.6-2.6,10.6-2.6C9.9,239.8,9.1,239.6,8.5,239.4z" />
        <path
          d="M291.7,104.8c21.7-14.9,32.6-22.3,32.6-22.5l32.8,22.5c-1.3-4.2-3.2-10.5-5.8-19s-4.6-14.8-5.9-19.1
		c15.9-12.2,26.4-20.3,31.5-24.1c-15.7-0.3-28.2-0.5-37.4-0.6c-1.1-0.1-1.8-0.3-2.3-0.4c-3.6-10.3-8-22.7-13.2-37.3
		c-6,17.4-10.3,29.9-13,37.5c-0.3,0-1.5,0-3.5,0.1l-36.2,0.9c21.2,16,31.8,24.1,31.8,24.1C303,67.7,299.3,80.2,291.7,104.8z"
        />
      </g>
    </SvgIcon>
  );
};

PatrickLogo.displayName = 'IconLiveLogo';
PatrickLogo.muiName = 'SvgIcon';

export default PatrickLogo;



// WEBPACK FOOTER //
// ./src/themes/patrick/components/PatrickLogo.js